export const hotCity = [
  {
    cityId: '146',
    cityName: '香港',
    pic: 'https://file.jufair.com/6b82ca09854e2b87665dcd9047f308b9.jpg',
    countryId: '26',
    continentId: '2',
  },
  {
    cityId: '95',
    cityName: '法兰克福',
    pic: 'https://file.jufair.com/f12e2c05bf6b18729341d0887b9c47ef.jpg',
    countryId: '73',
    continentId: '3',
  },
  {
    cityId: '129',
    cityName: '拉斯维加斯',
    pic: 'https://file.jufair.com/5b41bb21f57f5cc817706e129e89ff32.jpg',
    countryId: '127',
    continentId: '5',
  },
  {
    cityId: '238',
    cityName: '圣保罗',
    pic: 'https://file.jufair.com/d6dbc46e70a427aa7eb2499ab7feeffe.jpg',
    countryId: '230',
    continentId: '6',
  },
  {
    cityId: '10',
    cityName: '东京',
    pic: 'https://file.jufair.com/9f9aedcc8be3c8c09c53f84d31442029.jpg',
    countryId: '9',
    continentId: '2',
  },
  {
    cityId: '91',
    cityName: '巴黎',
    pic: 'https://file.jufair.com/5cdc9258318654c0e40559998230a00a.jpg',
    countryId: '72',
    continentId: '3',
  },
  {
    cityId: '521',
    cityName: '上海',
    pic: 'null',
    countryId: '519',
    continentId: '1',
  },
  {
    cityId: '522',
    cityName: '深圳',
    pic: 'null',
    countryId: '520',
    continentId: '1',
  },
  {
    cityId: '149',
    cityName: '新加坡',
    pic: 'https://file.jufair.com/2db45a480766b344747db313fdd5048b.jpg',
    countryId: '29',
    continentId: '2',
  },
  {
    cityId: '274',
    cityName: '胡志明',
    pic: null,
    countryId: '32',
    continentId: '2',
  },
  {
    cityId: '150',
    cityName: '新德里',
    pic: null,
    countryId: '37',
    continentId: '2',
  },
  {
    cityId: '151',
    cityName: '孟买',
    pic: 'https://file.jufair.com/f2cfaeef4fb68b2483b0b56652751cd6.jpg',
    countryId: '37',
    continentId: '2',
  },
  {
    cityId: '316',
    cityName: '曼谷',
    pic: 'null',
    countryId: '315',
    continentId: '2',
  },
  {
    cityId: '90',
    cityName: '伦敦',
    pic: 'https://file.jufair.com/834eb4c8be4b707685fffa1e3b886801.jpg',
    countryId: '71',
    continentId: '3',
  },
  {
    cityId: '92',
    cityName: '柏林',
    pic: null,
    countryId: '73',
    continentId: '3',
  },
  {
    cityId: '93',
    cityName: '慕尼黑',
    pic: 'https://file.jufair.com/1d79d1af2eeb4f53b487e88d0a71f262.jpg',
    countryId: '73',
    continentId: '3',
  },
  {
    cityId: '96',
    cityName: '科隆',
    pic: 'https://file.jufair.com/82da6d5e4c27c889a75582d3464c7479.jpg',
    countryId: '73',
    continentId: '3',
  },
  {
    cityId: '97',
    cityName: '杜塞尔多夫',
    pic: null,
    countryId: '73',
    continentId: '3',
  },
  {
    cityId: '98',
    cityName: '埃森',
    pic: null,
    countryId: '73',
    continentId: '3',
  },
  {
    cityId: '99',
    cityName: '汉诺威',
    pic: null,
    countryId: '73',
    continentId: '3',
  },
  {
    cityId: '108',
    cityName: '米兰',
    pic: 'https://file.jufair.com/b5422606cff5e5f2514d8a75a8d1c61e.jpg',
    countryId: '74',
    continentId: '3',
  },
  {
    cityId: '113',
    cityName: '莫斯科',
    pic: null,
    countryId: '75',
    continentId: '3',
  },
  {
    cityId: '177',
    cityName: '波兹南',
    pic: null,
    countryId: '88',
    continentId: '3',
  },
  {
    cityId: '200',
    cityName: '开普敦',
    pic: null,
    countryId: '189',
    continentId: '4',
  },
  {
    cityId: '128',
    cityName: '纽约',
    pic: 'https://file.jufair.com/6cd14554732e0a2c5f2eaa90898a5c84.jpg',
    countryId: '127',
    continentId: '5',
  },
  {
    cityId: '131',
    cityName: '芝加哥',
    pic: null,
    countryId: '127',
    continentId: '5',
  },
  {
    cityId: '219',
    cityName: '多伦多',
    pic: null,
    countryId: '209',
    continentId: '5',
  },
  {
    cityId: '239',
    cityName: '里约',
    pic: null,
    countryId: '230',
    continentId: '6',
  },
  {
    cityId: '222',
    cityName: '墨西哥城',
    pic: null,
    countryId: '210',
    continentId: '5',
  },
  {
    cityId: '258',
    cityName: '墨尔本',
    pic: null,
    countryId: '255',
    continentId: '49',
  },
  {
    cityId: '63',
    cityName: '伊斯坦布尔',
    pic: null,
    countryId: '57',
    continentId: '50',
  },
  {
    cityId: '60',
    cityName: '迪拜',
    pic: 'https://file.jufair.com/177f66bdf2165fb02eec83a8b134c23d.jpg',
    countryId: '59',
    continentId: '50',
  },
  {
    cityId: '12',
    cityName: '北京',
    pic: 'https://file.jufair.com/a5b56dca732ff58c3b5b2807b50d3120.jpg',
    countryId: '11',
    continentId: '1',
  },
  {
    cityId: '556',
    cityName: '重庆',
    pic: 'null',
    countryId: '524',
    continentId: '1',
  },
  {
    cityId: '604',
    cityName: '广州市',
    pic: null,
    countryId: '528',
    continentId: '1',
  },
];

export const hotCountry = [
  {
    countryId: '9',
    countryName: '日本',
    countryEnglishName: 'Japan',
    pic: 'https://file.jufair.com/5d52616b63ebb7521433b702f27d3887.png',
    continentId: '2',
  },
  {
    countryId: '73',
    countryName: '德国',
    countryEnglishName: 'Germany',
    pic: 'https://file.jufair.com/f06dacb90176a0eecac8e9b160fe0785.png',
    continentId: '3',
  },
  {
    countryId: '127',
    countryName: '美国',
    countryEnglishName: 'America',
    pic: 'https://file.jufair.com/c5c06f2622240ae411679c6bb9954465.png',
    continentId: '5',
  },
  {
    countryId: '210',
    countryName: '墨西哥',
    countryEnglishName: 'Mexico',
    pic: 'https://file.jufair.com/6ac6555a32207cbfb478b00c3de4713c.png',
    continentId: '5',
  },
  {
    countryId: '230',
    countryName: '巴西',
    countryEnglishName: 'Brazil',
    pic: 'https://file.jufair.com/889061fdc00557ded7f745bf5ddf6bcd.png',
    continentId: '6',
  },
  // {
  //   countryId: '231',
  //   countryName: '阿根廷',
  //    countryEnglishName: 'Argentina',
  //   pic:
  //     'https://file.jufair.com/fd6f0a96093de555d7ccc3d4d324220b.png',
  //   continentId: '6',
  // },
  {
    countryId: '32',
    countryName: '越南',
    countryEnglishName: 'Vietnam',
    pic: 'https://file.jufair.com/75bf5621f23d0d471ed2c8091059044b.png',
    continentId: '2',
  },
  {
    countryId: '57',
    countryName: '土耳其',
    countryEnglishName: 'Türkiye',
    pic: 'https://file.jufair.com/ef90bb5acf8868f3c8de61cb12bd89d2.png',
    continentId: '50',
  },
  // {
  //   countryId: '58',
  //   countryName: 'Iran',
  // countryEnglishName: '',
  //   pic:
  //     'https://file.jufair.com/7365e46a0d012fed14629883eba5234b.jpg',
  //   continentId: '50',
  // },
  {
    countryId: '37',
    countryName: '印 度',
    countryEnglishName: 'India',
    pic: 'https://file.jufair.com/b89dc5dc17b702a3423e260dec975af9.png',
    continentId: '2',
  },
  {
    countryId: '18',
    countryName: '韩国',
    countryEnglishName: 'Korea',
    pic: 'https://file.jufair.com/0ae2e30ec97ea4d7093af904106e7a2b.png',
    continentId: '2',
  },
  {
    countryId: '59',
    countryName: '阿联酋',
    countryEnglishName: 'The United Arab Emirates',
    pic: 'https://file.jufair.com/da930c706df582a86676ba543c06636a.png',
    continentId: '50',
  },
  // {
  //   countryId: '67',
  //   countryName: '以色列',
  // countryEnglishName: 'Israel',
  //   pic: 'https://file.jufair.com/7291f5a415eada154db4b169fd429475.jpg?x-oss-process=image/watermark,image_YWQ1YTlkZTczY2E3YzJiMzFlZDgxYWU5NDZkNjYxNzMucG5nP3gtb3NzLXByb2Nlc3M9aW1hZ2UvcmVzaXplLHdfNzA,t_30,g_se,x_10,y_10',
  //   continentId: '50',
  // },
  {
    countryId: '71',
    countryName: '英国',
    countryEnglishName: 'Britain',
    pic: 'https://file.jufair.com/95180c58a1879306d0a7078fdfdf6e44.png',
    continentId: '3',
  },
  {
    countryId: '72',
    countryName: '法国',
    countryEnglishName: 'France',
    pic: 'https://file.jufair.com/6ff67d4bf891f3eb9dfcf3540f7fd2ae.jpg',
    continentId: '3',
  },
  // {
  //   countryId: '88',
  //   countryName: '波兰',
  // countryEnglishName: 'Poland',
  //   pic: 'https://file.jufair.com/c3b66102933837e4a9f91428bf21cb01.png',
  //   continentId: '3',
  // },
  {
    countryId: '74',
    countryName: '意大利',
    countryEnglishName: 'Italy',
    pic: 'https://file.jufair.com/4eea2320f3237476f079b910b0c7364f.png',
    continentId: '3',
  },
  {
    countryId: '75',
    countryName: '俄罗斯',
    countryEnglishName: 'Russia',
    pic: 'https://file.jufair.com/5ec26675a5445464cdb57036a6834c85.png',
    continentId: '3',
  },
  {
    countryId: '76',
    countryName: '西班牙',
    countryEnglishName: 'Spain',
    pic: 'https://file.jufair.com/c000a264fdca4b00e144fb48dd17101e.png',
    continentId: '3',
  },
  // {
  //   countryId: '80',
  //   countryName: '捷克',
  // countryEnglishName: 'Czech Republic',
  //   pic: 'https://file.jufair.com/21e758a04a39bb574438ee532e63ea17.png',
  //   continentId: '3',
  // },
  // {
  //   countryId: '64',
  //   countryName: '沙特阿拉伯',
  // countryEnglishName: 'Saudi Arabia',
  //   pic: 'https://file.jufair.com/6fc7e590022d40335eac625e0c6908fb.jpg',
  //   continentId: '50',
  // },
  {
    countryId: '255',
    countryName: '澳大利亚',
    countryEnglishName: 'Australia',
    pic: 'https://file.jufair.com/61e2259502bc0fc6bfccb7b38e6dde8a.png',
    continentId: '49',
  },
];
